import React from "react";
import "./WhatsNewSection.css";

type NewsItem = {
  title: string;
  description: string;
  link?: string;
};

const NEWS_ITEMS: NewsItem[] = [
  {
    title: "Introducing the Atom DEX Alpha",
    description:
      "Crypto exchanges weren’t built for traders — they were built for volume. For too long, users have had to choose between speed and security, usability and decentralization, flexibility and control.",
  },
  {
    title: "The Atom Roadmap",
    description:
      "When Atom launched in 2026, it was introduced as a universal verifiable machine — a cryptographic system for proving anything, anywhere. That vision hasn’t changed. But its shape has evolved.",
  },
  {
    title: "Atom Milestones: A Look Back",
    description:
      "In the span of just a few years, Atom has evolved from an ambitious prototype to a globally recognized effort to transform how computation works at its core.",
  },
  {
    title: "Gridcrews: Choose Your Path",
    description:
      "Node Running started as individual contribution. You secured Glyphs. You completed quests. You built reputation.",
  },
];

const ArrowIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M5 19L19 5"
      stroke="#111"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 5H19V15.5"
      stroke="#111"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const WhatsNewSection: React.FC = () => {
  return (
    <section className="whats-new-section">
      <div className="whats-new-container">
        <div className="wn-header">
          <h2 className="wn-title">What’s New</h2>
        </div>

        <div className="wn-grid">
          {NEWS_ITEMS.map((item, idx) => (
            <div className="wn-card" key={idx}>
              <div className="wn-card-top">
                <h3 className="wn-card-title">{item.title}</h3>
                <span className="wn-card-icon">
                  <ArrowIcon />
                </span>
              </div>
              <p className="wn-card-desc">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatsNewSection;
